export default __webpack_public_path__ + "static/media/crop.f8b7e2da.svg";